import * as Yup from 'yup';
import { Formik } from 'formik';
import { RoundButton } from '@/components/UI/RoundButton';
import { InputTextField } from '@/components/UI/InputTextField';
import { DatePicker } from '@/kit/form/DatePicker';
import './index.scss';
import { useTranslation } from 'react-i18next';

const VALIDATION_SCHEMA = t =>
  Yup.object({
    start_date: Yup.mixed().required(t('profile_career_form.start_date_required')),
    company: Yup.string().required(t('profile_career_form.company_name_required')),
    position: Yup.string().required(t('profile_career_form.position_required')),
  });

const ProfileCareerForm = ({ career, onSubmit, onRemove }) => {
  const { t } = useTranslation('components');
  return (
    <Formik
      enableReinitialize
      validationSchema={VALIDATION_SCHEMA(t)}
      initialValues={{
        company: career ? career.company : '',
        position: career ? career.position : '',
        start_date: career?.start_date ? new Date(career.start_date) : null,
        end_date: career?.end_date ? new Date(career.end_date) : null,
      }}
      onSubmit={(values, formikBag) => onSubmit(values, formikBag)}
    >
      {({ values, setFieldValue, errors, touched, handleChange, handleSubmit }) => (
        <form className="profile-career-form" onSubmit={handleSubmit}>
          <h1 className="profile-career-form__title f-32 f-500">
            {career
              ? t('profile_career_form.edit_career')
              : t('profile_career_form.add_new_career')}
          </h1>
          <div className="career-item">
            <div className="career-item__dates">
              <DatePicker
                name="start_date"
                label={t('profile_career_form.start_date')}
                value={values.start_date}
                onChange={date => setFieldValue('start_date', date)}
                onReset={() => setFieldValue('start_date', null)}
              />
              <DatePicker
                name="end_date"
                label={t('profile_career_form.end_date')}
                value={values.end_date}
                onChange={date => setFieldValue('end_date', date)}
                onReset={() => setFieldValue('end_date', null)}
              />
            </div>
            <InputTextField
              label={t('profile_career_form.company')}
              name="company"
              onChange={handleChange}
              value={values.company}
              error={errors.company && touched.company && errors.company}
              className="profile-career-form__field"
            />

            <InputTextField
              label={t('profile_career_form.position')}
              onChange={handleChange}
              value={values.position}
              error={errors.position && touched.position && errors.position}
              name="position"
              className="profile-career-form__field"
            />
          </div>

          <div className="profile-career-form__buttons">
            {!!career && (
              <RoundButton
                label={t('profile_career_form.remove')}
                type="button"
                onClick={onRemove}
                fullWidth
                className="profile-career-form__button"
              />
            )}
            <RoundButton
              label={career ? t('profile_career_form.update') : t('profile_career_form.add')}
              type="submit"
              onSubmit={handleSubmit}
              fillBackground
              fullWidth
              className="profile-career-form__button"
            />
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ProfileCareerForm;
